export function getMatchingScoreValue(score: number): number {
  if (!score || score <= 0) { return 0; }
  // small epsilon: e.g. 0.29 * 100 gives 28.999999999999996
  return Math.floor(score * 100 + 1e-9);
}
